import React from "react";
import Svg from "./svgs/Svg";

export default function Logo() {
  return <Svg iconName="Logo" className="logo" />;
}
